import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRightOutlined } from '@ant-design/icons';
import useReveal from '../useReveal';
import { ROLE_CONFIGS, ROLE_SLUGS } from './roleConfigs';
import './AIERolesCompact.css';

/**
 * AIERolesCompact — "Hire for any role." (mock ruling #14, Aug 5; amended Sep 1 2026):
 * ALL role cards render open by default — the "+N more roles" expand tile is
 * removed (Nitish's ruling, Sep 1: hidden cards were already in the prerendered
 * HTML, so this is a visibility-only change; ~2 extra grid rows of height).
 * The cta_click{roles_expand} event series ends at this deploy (control removed).
 *
 * SEO: unchanged — every role link renders in the DOM on first paint, so the
 * prerendered HTML carries all internal links into the role cluster; this
 * section remains the internal-linking spine from the high-authority product page.
 *
 * TOP_SLUGS = the top role pages by GA4 views (28d pull, Aug 5 2026) — they
 * lead the grid. Revisit the order when traffic patterns change meaningfully.
 */
const TOP_SLUGS = [
  'ai-social-media-manager',
  'ai-project-manager',
  'ai-research-assistant',
  'ai-bookkeeper',
  'ai-operations-manager',
  'ai-receptionist',
  'ai-seo-specialist',
];

const AIERolesCompact = () => {
  const [ref, visible] = useReveal();
  const rest = ROLE_SLUGS.filter((s) => !TOP_SLUGS.includes(s));

  return (
    <section className="aie-rolesc aie-section" ref={ref} id="aie-roles">
      <div className={`aie-reveal ${visible ? 'is-visible' : ''}`}>
        <div className="aie-section-head">
          <h2 className="aie-section-title aie-display">Hire for any role.</h2>
          <p className="aie-section-sub">
            The roles teams hire for most, with real prompts, honest limits,
            and the economics.
          </p>
        </div>
        <div className="aie-rolesc__grid">
          {[...TOP_SLUGS, ...rest].map((slug) => (
            <Link className="aie-rolesc__card" key={slug} to={`/ai-employees/${slug}`}>
              <span>{ROLE_CONFIGS[slug].roleDisplay}</span>
              <ArrowRightOutlined />
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default AIERolesCompact;
